/**
 * Login del BO — rediseño 02/09 (pedido Sol): fotos reales de winclap.com
 * orbitando (LoginPhotoHero) con la card de login CENTRADA. Google federado es
 * la ÚNICA puerta (Vault F0: el app client de Cognito no tiene flujos de
 * usuario/contraseña); el paso legacy de "cambiar contraseña" se quitó en F2.
 */
import { useState } from 'react';
import { signInWithRedirect } from 'aws-amplify/auth';
import { useTranslation, Trans } from 'react-i18next';
import logo from '@/assets/winclap-logo.svg';
import { LoginPhotoHero } from '@/components/ui/scroll-morph-hero';

const PILLARS = [
  { label: 'Studio', color: '#CEABFF' },
  { label: 'Media', color: '#FE805B' },
  { label: 'Data', color: '#87DBFF' },
  { label: 'Consulting', color: '#FFD447' },
];

export function LoginPage() {
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);

  async function handleGoogleLogin() {
    setError(null);
    try {
      await signInWithRedirect({ provider: 'Google' });
    } catch (err: any) {
      setError(err.message || t('auth.errors.google_error'));
    }
  }

  return (
    <div className="h-screen w-full">
      <LoginPhotoHero>
        <div className="w-full max-w-sm rounded-2xl border border-brand-gray4 bg-white/95 p-8 shadow-2xl backdrop-blur-xs">
          <img src={logo} alt="Winclap" className="mx-auto mb-6 h-6 w-auto object-contain" />

          <p className="mb-2 text-center text-[10px] font-medium uppercase tracking-widest text-brand-gray3">
            {/* i18n-ok: marca */}
            Back Office
          </p>

          <h1 className="text-center font-display text-3xl font-normal leading-tight text-brand-gray1">
            <Trans i18nKey="auth.login.tu_espacio_de_trabajo_interno" components={{ br: <br /> }} />
          </h1>

          <div className="mt-8 space-y-4">
            {error && (
              <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p>
            )}

            <button
              type="button"
              onClick={handleGoogleLogin}
              className="flex w-full items-center justify-center gap-3 rounded-md border border-brand-gray4 bg-white px-4 py-3 text-sm font-medium text-brand-gray1 transition-colors hover:bg-brand-offwhite focus:outline-hidden focus:ring-2 focus:ring-[#E5E5E5] focus:ring-offset-2"
            >
              <svg className="h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
              </svg>
              {t('auth.login.ingresar_con_google')}
            </button>

            <p className="text-center text-xs text-[#BBBBBB]">{t('auth.login.solo_para_cuentas_winclap')}</p>
          </div>

          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {PILLARS.map(({ label, color }) => (
              <span
                key={label}
                className="rounded-full border px-2.5 py-1 text-[10px] font-medium tracking-wider"
                style={{ color, borderColor: `${color}55` }}
              >
                {label.toUpperCase()}
              </span>
            ))}
          </div>

          <p className="mt-6 text-center text-xs text-[#BBBBBB]">
            {/* i18n-ok: marca + año */}
            ✦ Winclap · {new Date().getFullYear()}
          </p>
        </div>
      </LoginPhotoHero>
    </div>
  );
}
